<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/taskManage">任务列表</BreadcrumbItem>
        <BreadcrumbItem>新增</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/taskManage" slot="extra">返回</router-link>
    <Form ref="formValidate" :model="formInline" :rules="ruleInline" inline>
      <FormItem prop="jobName" label="任务名称">
        <Input
          type="text"
          :style="{width:'400px',margin:'0 auto'}"
          v-model="formInline.jobName"
          placeholder="请输入任务名称"
        ></Input>
      </FormItem>
      <FormItem prop="beanName" label="beanName">
        <Input
          type="text"
          :style="{width:'400px',margin:'0 auto'}"
          v-model="formInline.beanName"
          placeholder="请输入beanName"
        ></Input>
      </FormItem>
      <FormItem prop="params" label="任务参数">
        <Input
          type="text"
          :style="{width:'400px',margin:'0 auto'}"
          v-model="formInline.params"
          placeholder="请输入任务参数"
        ></Input>
      </FormItem>
      <FormItem prop="cronExpression" label="任务corn表达式">
        <Input
          type="text"
          :style="{width:'400px',margin:'0 auto'}"
          v-model="formInline.cronExpression"
          placeholder="请输入任务参数"
        ></Input>
      </FormItem>
      <FormItem prop="status" label="状态">
        <Select
          v-model="formInline.status"
          placeholder="请选择状态">
          <Option :value="0" :key="0">生效</Option>
          <Option :value="1" :key="1">停用</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input
          type="text"
          :style="{width:'400px',margin:'0 auto'}"
          v-model="formInline.remark"
          placeholder="请输入备注信息"
        ></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="save('formValidate')">保存</Button>
        <Button style="margin-left: 8px" @click="cancel('formValidate')">取消</Button>
      </FormItem>
    </Form>
  </Card>
</template>
<script>
  export default {
    data() {
      return {
        formInline: {
          jobName: "",
          beanName: "",
          params: "",
          cronExpression: "",
          status: "",
          remark: ""
        },
        ruleInline: {
          jobName: [
            {required: true, message: '请输入任务名称'}
          ],
          beanName: [
            {required: true, message: "请输入beanName"}
          ],
          params: [
            {required: false, message: "请输入任务参数"}
          ],
          cronExpression: [
            {required: true, message: "请输入cron表达式"}
          ],
          status: [
            {required:true, message:"请选择状态"}
          ],
          remark: [
            {required: true, message: "请输入备注信息"}
          ]
        },
        query: {}
      }
    },
    methods: {
      save(name) {
        let data = {...this.formInline};
        let path = 'addScheduleTask';
        this.$refs[name].validate(valid => {
          if (valid) {
            this.$api[path](data).then((res) => {
              if (res.code == '200') {
                this.$Message.success("任务新增成功");
                this.$router.replace({path: '/taskManage'});
              }
            });
          }
        })
      },
      cancel(name) {
        this.$refs[name].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/task/taskAdd.vue